export default __webpack_public_path__ + "static/media/linkdn.108a5a85.png";